<div class="flex flex-col items-center justify-center h-full">
  <ng-container *ngIf="!isClaimsPageVisit && !loginDisabled; else messageBlock">
    <ws-portal-header
      [status]="
        errors
          ? statusTypes.Error
          : email.sent
          ? statusTypes.EmailSent
          : statusTypes.Welcome
      "
      [errorType]="errorType"
    ></ws-portal-header>
    <ws-enter-email-card #email class="min-w-1/2" (signInError)="handleSignInError($event)"></ws-enter-email-card>
  </ng-container>
  <ng-template #messageBlock>
    <div class="min-w-1/2 p-8 rounded shadow bg-white text-center">
      <ng-container *ngIf="isClaimsPageVisit; else loginDisabledBlock">
        <ng-container *ngIf="sanitizedClaimsMessage; else defaultClaimsMessage">
          <div class="text-left" [innerHTML]="sanitizedClaimsMessage"></div>
        </ng-container>
        <ng-template #defaultClaimsMessage>
          <h2 class="text-2xl font-semibold mb-4">Please call {{ contactPhoneLabel }}.</h2>
          <p class="mb-2">Your support team is standing by to assist you with your warranty. Call today!</p>
        </ng-template>
      </ng-container>
      <ng-template #loginDisabledBlock>
        <h2 class="text-2xl font-semibold mb-4">Please call {{ contactPhoneLabel }}.</h2>
        <p class="mb-2">Your support team is standing by to assist you with your warranty. Call today!</p>
      </ng-template>
    </div>
  </ng-template>
</div>
